import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RyderInput from '../RyderInput';
import RyderButton from '../RyderButton';
import { validateAlphanumeric } from '../../utils/helper';
import Spinner from '../Spinner';
import axios from '../../utils/axios';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';
import {
  Form,
  Text,
} from './styledComponents';

/**
 * SearchInvoiceForm Component documentation
 * @property       {func} onSubmit Function to handle onSubmit event
 *
 */

class SearchInvoiceForm extends Component {
  state = {
    errorData: false,
    showSpinner: false,
    alertData: {
      showAlert: false,
      alertMessage: '',
      alertIcon: 'success',
      alertTitle: 'Success...',
    },
    searchData: {
      accountNumber: '',
      invoiceNumber: '',
    },
  };
  componentDidMount() {
    this.setState({
      errorData: false,
      showSpinner: false,
      alertData: {
        showAlert: false,
        alertMessage: '',
        alertIcon: 'success',
        alertTitle: 'Success...',
      },
      searchData: {
        accountNumber: '',
        invoiceNumber: '',
      },
    });
  }
  validateError = () => {
    const {
      searchData: {
        accountNumber,
        invoiceNumber,
      },
    } = this.state;
    if (!validateAlphanumeric(accountNumber) ||
        !validateAlphanumeric(invoiceNumber)) {
      this.setState({
        errorData: true,
      });
    } else {
      this.setState({
        errorData: false,
      });
    }
  }
  handleSubmit = (ev) => {
    const {
      onSubmit,
    } = this.props;
    const {
      searchData: {
        accountNumber,
        invoiceNumber,
      },
    } = this.state;
    ev.preventDefault();
    this.validateError();
    const {
      errorData
    } = this.state;
    if(!errorData) {
      this.setState({ showSpinner: true });
      axios.post('/search', { invoiceNumber, accountNumber })
            .then((result) => {
              if(result.status === 200 && result.data.success) {
                let isInvoicePaid = result.data.data.invoice.paid;

                if(isInvoicePaid) {
                  this.setState({
                    showSpinner: false,
                    alertData: {
                      showAlert: true,
                      alertIcon: 'success',
                      alertMessage: 'Invoice has been paid',
                      alertTitle: 'Success',
                    },
                  });
                } else {
                  this.setState({
                    showSpinner: false,
                  });
                  onSubmit('results', result.data.data.invoice, accountNumber);
                }
              }
              else
                this.setState({
                  showSpinner: false,
                  alertData: {
                    showAlert: true,
                    alertIcon: 'error',
                    alertMessage: 'An Error has ocurred.',
                    alertTitle: 'Oops...',
                  },
                });
            }).catch((error) => {
              let errorMessage = 'An Error has ocurred.';

              if (error.response) {
                if(error.response.data && error.response.data.data && error.response.data.data.message)
                   errorMessage = error.response.data.data.message;
                else if(error.request.statusText)
                  errorMessage = error.message + ' (' + error.request.statusText + ').';
              } else if (error.request && error.request.statusText)
                errorMessage = error.message + ' (' + error.request.statusText + ').';
              else
                errorMessage = error.message;

              this.setState({
                showSpinner: false,
                alertData: {
                  showAlert: true,
                  alertIcon: 'error',
                  alertMessage: errorMessage,
                  alertTitle: 'Oops...',
                },
              });
            });
    }
  };
  hideAlert = () => {
    const {
      alertData,
    } = this.state;
    this.setState({
      alertData: {
        ...alertData,
        showAlert: false,
      }
    });
  };
  setSearchData = (text, fieldName) => {
    const { searchData } = this.state;
    searchData[fieldName] = text.trim();
    this.setState({ searchData });
    this.validateError();
  };
  getErrorText = (field) => {
    const {
      searchData: {
        accountNumber,
        invoiceNumber,
      },
    } = this.state;
    if(field === 'accountNumber')
      return !validateAlphanumeric(accountNumber) ? 'Please, enter a valid Acct #' : '';
    else if(field === 'invoiceNumber')
        return !validateAlphanumeric(invoiceNumber) ? 'Please, enter a valid Invoice #' : '';
    else
      return '';
  };
  render() {
    const {
      errorData,
      showSpinner,
      alertData: {
        showAlert,
        alertMessage,
        alertIcon,
        alertTitle,
      },
      searchData: {
        accountNumber,
        invoiceNumber,
      },
    } = this.state;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Text>{'Search by Account + Invoice number'}</Text>
        <RyderInput
          label={'Account #'}
          name={'accountNumber'}
          type={'text'}
          required
          value={accountNumber}
          onChange={this.setSearchData}
          errorText={errorData ? this.getErrorText('accountNumber') : ''}
        />
        <Text>{'Account number (XXXXX-XXXXXX)'}</Text> 
        <RyderInput
          label={'Invoice #'}
          name={'invoiceNumber'}
          type={'text'}
          required
          value={invoiceNumber}
          onChange={this.setSearchData}
          errorText={errorData ? this.getErrorText('invoiceNumber') : ''}
        />
        <RyderButton>Submit</RyderButton>
        <SweetAlert
          title={alertTitle}
          show={showAlert}
          type={alertIcon}
          text={alertMessage}
          onConfirm={this.hideAlert}
        />
        { showSpinner && <Spinner /> }
      </Form>
    );
  }
}

SearchInvoiceForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default SearchInvoiceForm;



// WEBPACK FOOTER //
// ./src/components/SearchInvoiceForm/index.js